/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';


interface BatchTraceabilitySectionProps {
  batchDetails?: any;
  powderBatchDetails?: any;
}

const BatchTraceabilitySection: React.FC<
  BatchTraceabilitySectionProps
> = ({batchDetails, powderBatchDetails }) => {
  const { t } = useTranslation();

  const batch = batchDetails?.media_batch_identifier || "-";
  const volume = batchDetails?.dispensing_summary?.total_dispensed_volume_ml || 0;


  return ( 
    <section className="bg-white border border-slate-200 rounded-lg overflow-hidden w-full">
    <div className="flex items-center bg-[#F8FAFC] gap-4 px-6 py-2" style={{ borderBottom: "1px solid #D6DEE8" }}>
        <div className="w-6 h-6 rounded-sm bg-slate-900 text-white flex items-center justify-center font-black text-[10px]">
        08
        </div>
        <h3 className="text-[13px] font-bold uppercase tracking-wide text-[#1E2B4D] mt-[7px]">
        {t("mediaPrepBatch.mediaPrepBatchDetails.BATCH TRACEABILITY")}
        </h3>
    </div>

    <div className="px-5 p-2 flex items-center gap-6">

        {/* Raw Material Lot */}
        <div className="flex-1 border border-slate-200 rounded-lg overflow-hidden">
        <div className="py-1.5 text-center bg-[#F8FAFC] leading-none">
            <p className="text-[10px] font-bold uppercase text-slate-500 mb-2 leading-none">{t("mediaPrepBatch.mediaPrepBatchDetails.RAW MATERIAL LOT")}</p>
            <p className="text-[14px] font-bold text-[#1E2B4D] leading-none m-0">{powderBatchDetails?.batch_info?.manufacturer_name || "-"}</p>
            <p className="text-[13px] font-semibold text-[#1E2B4D] leading-none mt-1">{powderBatchDetails?.batch_info?.catalog_number || "-"}</p>
        </div>
        </div>

        <div className="flex items-center justify-center">
            <span className="material-symbols-outlined text-[32px] text-slate-400" style={{ fontVariationSettings: "'FILL' 0,'wght' 300,'GRAD' 0,'opsz' 24" }}>{t("mediaPrepBatch.mediaPrepBatchDetails.arrow_forward")}</span>
        </div>

        {/* Media Batch */}
        <div className="flex-1 border border-slate-200 rounded-lg overflow-hidden">
        <div className="py-1.5 text-center bg-[#F8FAFC] leading-none">
            <p className="text-[10px] font-bold uppercase text-slate-500 mb-2 leading-none">{t("mediaPrepBatch.mediaPrepBatchDetails.MEDIA BATCH")}</p>
            <p className="text-[14px] font-bold text-[#1E2B4D] leading-none m-0">{batch}</p>
            <p className="text-[13px] font-semibold text-[#1E2B4D] leading-none mt-1">{volume} mL</p>
        </div>
        </div>

        <div className="flex items-center justify-center">
            <span className="material-symbols-outlined text-[32px] text-slate-400" style={{ fontVariationSettings: "'FILL' 0,'wght' 300,'GRAD' 0,'opsz' 24" }}>{t("mediaPrepBatch.mediaPrepBatchDetails.arrow_forward")}</span>
        </div>

        {/* EM Plates Generated */}
        <div className="flex-1 border border-slate-200 rounded-lg overflow-hidden">
        <div className="py-1.5 text-center bg-[#F8FAFC] leading-none">
            <p className="text-[10px] font-bold uppercase text-slate-500 mb-2 leading-none">{t("mediaPrepBatch.mediaPrepBatchDetails.EM PLATES GENERATED")}</p>
            <p className="text-[14px] font-bold text-green-600 leading-none m-0">{batchDetails?.dispensing_summary?.quantity_dispensed || 0} Plates</p>
            <p className="text-[13px] font-semibold text-[#1E2B4D] leading-none mt-1">(So Far)</p>
        </div>
        </div>

    </div>
    </section>
)};
  
export default BatchTraceabilitySection;    